<!-- 图片裁切子组件 -->
<template>
  <div>
    <a-modal
      title="裁切图片"
      :visible="cut_visible"
      :confirm-loading="cut_confirmLoading"
      @ok="cutHandleOk"
      @cancel="cutHandleCancel"
      width="700px"
      okText="确认"
    >
      <div
        :style="{ width: cropper_width + 'px', height: cropper_height + 'px' }"
        style="margin: auto"
		:key="cor_option.img"
		v-if="cor_option.img"
      >
        <vueCropper
          ref="cropper"
          :img="cor_option.img"
          :outputSize="cor_option.size"
          :outputType="cor_option.outputType"
          :canScale="false"
          :info="true"
          :full="cor_option.full"
          :fixed="fixed"
          :fixed-number="fixedNumber"
          :can-move="cor_option.canMove"
          :can-move-box="cor_option.canMoveBox"
          :fixed-box="cor_option.fixedBox"
          :original="cor_option.original"
          :auto-crop="cor_option.autoCrop"
          :auto-crop-width="cor_option.autoCropWidth"
          :auto-crop-height="cor_option.autoCropHeight"
          :center-box="cor_option.centerBox"
        ></vueCropper>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
export default {
  name: "cropperImgModal_",
  props: [],
  components: {
    VueCropper,
  },
  data() {
    return {
      cut_visible: false, // 裁切图片
      cut_confirmLoading: false, // 裁切图片弹窗确认按钮加载状态
      cut_img: "", // 要裁切的图片
      cor_option: {
		img:"",
        // img: "https://oss.gzlize.com/gzh-local-message-material/amtyYtZR3wfDD4NL8E9Ee5vt32DU4Fhteq9Ka5uX.jpg",
        // img: 'https://avatars2.githubusercontent.com/u/15681693?s=460&v=4',
        size: 0.1,
        full: false,
        outputType: "jpeg",
        canMove: false,
        fixedBox: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 160,
        autoCropHeight: 150,
        centerBox: true, // 截图框是否被限制在图片里面
        high: true,
        max: 99999,
      },
      show: true,
      fixed: true,
      fixedNumber: [23.47, 10],
      cropper_width: 0,
      cropper_height: 0,
      cropper_w_h: 1, // 原图与实际图的比值
      cropper_original_img_url: "", // 要进行裁切的原图链接
    };
  },
  methods: {
    cutImgHandle(c_img, fixed_n) {
      let that = this;
      this.cor_option.img = c_img;
      // 单图文的话，裁切比例就是1:1正方形
      this.fixedNumber = fixed_n || [10, 10];
      var img = new Image();
      img.src = this.cor_option.img;
      img.onerror = function () {
        alert(" 图片加载失败，请检查url是否正确");
        return false;
      };

      function img_ifo() {
        if (img.width >= img.height) {
          // 长图
          if (img.width < 500) {
            // 实际图片小于显示图片尺寸
            // 这里有一点要处理，是否要进行放大，目前是没有放大
            that.cropper_width = img.width;
            that.cropper_height = img.height;
          } else {
            // 实际图片大于等于显示图片尺寸
            that.cropper_width = 500;
            that.cropper_height = that.cropper_width * (img.height / img.width);
          }
          that.cropper_w_h = 500 / img.width;
        } else if (img.width == img.height) {
          // 正方形图
          that.cropper_width = 500;
          that.cropper_height = 500;
          that.cropper_w_h = 1;
        } else {
          // 高图
          if (img.width < 300) {
            // 图片小于显示宽高时
            // console.log(1111)
            that.cropper_width = img.width;
            that.cropper_height = img.height;
          } else {
            // 图片大于等于显示宽高时
            // console.log(2222)
            that.cropper_width = 300;
            that.cropper_height = that.cropper_width * (img.height / img.width);
          }
          that.cropper_w_h = 300 / img.width;
        }

        that.cut_visible = true;
      }

      if (img.complete) {
        // console.log('1',img.width+" "+img.height);
        // console.log('1',img.width,img.height);

        img_ifo();
      } else {
        img.onload = function () {
          // console.log('2',img.width+" "+img.height);
          img.onload = null; //避免重复加载

          img_ifo();
        };
      }
    },
    cutHandleOk(e) {
      let that = this;
      // x2-x1的值为裁切框的宽
      // y2-y1得出的值是裁切框的高
      // x1，y1则是X，Y坐标的起始点
      // console.log("获取坐标",this.$refs.cropper.getCropAxis())
      let data = this.$refs.cropper.getCropAxis();
      let w = Math.round(data.x2 - data.x1);
      let h = Math.round(data.y2 - data.y1);
      let x = Math.round(data.x1);
      let y = Math.round(data.y1);

      let s_w, s_h, s_x, s_y;
      if (that.cropper_w_h < 1) {
        // 表示实际图片尺寸大于显示尺寸
        s_w = Math.round(w / that.cropper_w_h);
        s_h = Math.round(h / that.cropper_w_h);
        s_x = Math.round(x / that.cropper_w_h);
        s_y = Math.round(y / that.cropper_w_h);
      } else {
        // 表示实际图片尺寸小于或者等于显示尺寸
        s_w = Math.round(w);
        s_h = Math.round(h);
        s_x = Math.round(x);
        s_y = Math.round(y);
      }

      let oss_text = `?x-oss-process=image/crop,x_${s_x},y_${s_y},w_${s_w},h_${s_h}`;
      // console.log("oss_texty",oss_text)
      // console.log("this.cor_option.img",this.cor_option.img.split('?'))

      // 这里需要再做一个处理，当图片链接本身就有这些x,y,w,h参数时，要进行去除
      let img_data = this.cor_option.img.split("?"); // 把图片链接后面的参数去掉
      // let gzh_data = this.gzhTabData[this.gzh_tab_index].contentData
      // if(gzh_data.e_type == 4){ // 图文
      // 	gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image = img_data[0] + oss_text
      // }
      // else { // 单图文
      // 	gzh_data.e_txtImg_image = img_data[0] + oss_text
      // }

      let c_img = img_data[0] + oss_text;
      this.$emit("cropper-ok", c_img);

      // this.cut_visible = false
    },
    cutHandleCancel() {
      this.cut_visible = false;
    },
  },
};
</script>

<style scoped></style>
